import React, { Component } from "react";
import domain from ".././../../../domain";
import axios from "axios";
import { Row, Col, Card, CardBody } from "mdbreact";
import { Link } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import moment from "moment";

// var jsPDF = require('jspdf');
// require('jspdf-autotable');
// var columns = ["S. No", "Trainee Name", "Clarity of Session Objective","Whether Objective met","Learning new Concepts","Faculty Presentation Skills","Usefulness of Presentation Material / Practical Handouts","Overall Session Evaluation","Average"];
export default class SessionWiseFeedbackReport extends Component {
  constructor() {
    super();
    this.state = {
      feedback: null,
      session: null,
      course_id: null,
      session_date: null,
      start_time: null,
      end_time: null,
      modal: false,
    };
  }

  componentDidMount() {
    this.getOverallFeedback();
    this.getSessionDetails();
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  // generatePdf= () => {
  //   var doc = new jsPDF('l','pt','a4');
  //   var totalPagesExp = "{total_pages_count_string}";

  //   var pageContent = function (data) {
  //       // HEADER
  //       doc.setFontSize(20);
  //       doc.setTextColor(40);
  //       doc.setFontStyle('normal');
  //       if (isro) {
  //         doc.addImage(isro.imagedata, data.settings.margin.left, 15, 30,30);
  //          // doc.addImage(isro, 'JPEG', data.settings.margin.left, 15, 10, 10);
  //       }
  //     doc.text("National Remote Sensing Center", data.settings.margin.left + 40, 30);

  //     doc.setLineCap(2);

  //     doc.line(20, 40,1000, 40);

  //   //  doc.line(30, 30, data.settings.margin.width, 20) // horizontal line

  //       // FOOTER
  //       var str = "Page " + data.pageCount;
  //       //alert(str)
  //       if (typeof doc.putTotalPages === 'function') {
  //           str = str + " of " + totalPagesExp;
  //       }
  //       doc.setFontSize(20);
  //       doc.text(str, data.settings.margin.left, doc.internal.pageSize.height -10);
  //   };

  //          doc.setFontSize(20);
  //          doc.setTextColor("#225566")
  //          doc.setFontStyle('helvetica');
  //         //  doc.fromHTML(document.getElementById('table-to-xls'), 10, 10,{

  //         //   'margin': 1,
  //         //   'pagesplit': true,

  //         // },page);
  //          var elem = document.getElementById("table-to-pdf");
  //          var res = doc.autoTableHtmlToJson(elem);
  //          console.log(res)
  //         // alert(res)

  //          doc.fromHTML(document.getElementById('content'),150,60);
  //          doc.autoTable(res.columns, res.data,
  //            {
  //             addPageContent: pageContent,
  //             startY:200,
  //              margin: {top: 60},
  //              theme:'grid',
  //              tableLineColor: [189, 195, 199],
  //       tableLineWidth: 0.75,
  //       styles: {

  //           lineColor: [44, 62, 80],
  //           lineWidth: 0.75
  //       },
  //              headerStyles:{overflow:'linebreak',text: {columnWidth: 'wrap',halign:"center"}},
  //              bodyStyles: {overflow:'linebreak',align: 'right',columnWidth:'wrap',halign:"right"},
  //             // columnStyles: {text: {columnWidth: 'wrap'},halign:"right"},
  //              columnStyles:{
  //               1: {halign:'left'}
  //              },
  //             // startY: doc.autoTableEndPosY() + 20,
  //              alternateRowStyles: {
  //               fillColor: [255, 255, 0]
  //           },
  //           drawRow: function (row, data) {
  //             // Colspan
  //             doc.setFontStyle('bold');
  //             doc.setFontSize(10);
  //             if (row.index === 28) {
  //                 doc.setTextColor(200, 0, 0);
  //                 doc.rect(data.settings.margin.left, row.y, data.table.width, 20, 'S');
  //                 doc.autoTableText("Total", data.settings.margin.left + data.table.width / 2, row.y + row.height / 2, {
  //                     halign: 'center',
  //                     valign: 'middle'
  //                 });
  //                 data.cursor.y += 20;
  //             }
  //         },

  //             }
  //           );

  //   // Total page number plugin only available in jspdf v1.0+
  //   if (typeof doc.putTotalPages === 'function') {
  //       doc.putTotalPages(totalPagesExp);
  //   }

  //   return doc;
  // };

  //       exportToPdf=(e)=>
  //       {
  //       let pdf=this.generatePdf()
  //       window.open(pdf.output('bloburl'), '_blank');

  //     //   // pdf.save('test.pdf');
  //       }

  getOverallFeedback() {
    let id = this.props.match.params.id;
    console.log(id);
    axios
      .get(`${domain.DBServer}/fetch-session-feedback/${id}`)
      .then((result) => {
        this.setState({ feedback: result.data });
      })
      .catch((err) => console.log(err));
  }
  getSessionDetails() {
    let id = this.props.match.params.id;
    console.log(id);
    axios
      .get(`${domain.DBServer}/fetch-session/${id}`)
      .then((result) => {
        this.setState({
          session: result.data,
          course_id: result.data[0].course_id,
          session_date: result.data[0].session_date,
          start_time: result.data[0].start_time,
          end_time: result.data[0].end_time,
        });
        console.log(result.data);
      })
      .catch((err) => console.log(err));
  }

  render() {
    const feedback = this.state.feedback;

    const session = this.state.session;

    let lecture_name, topic;
    if (session) {
      console.log(session);
      session.map((response, key) => {
        lecture_name = response.lecturer_name;
        topic = response.title;
        return true;
      });
    }
    console.log(lecture_name);
    let feedbackTable,
      totalclarity = 0,
      totalobj = 0,
      totallearn = 0,
      totalfac = 0,
      totaldemo = 0,
      totalov = 0,
      totalavg = 0;
    let avg,
      totalrows = 0;
    if (feedback) {
      feedbackTable = feedback.map((response, key) => {
        avg =
          (parseInt(response.feedback.clarity, 10) +
            parseInt(response.feedback.objective, 10) +
            parseInt(response.feedback.learning, 10) +
            parseInt(response.feedback.faculty, 10) +
            parseInt(response.feedback.demonstration, 10) +
            parseInt(response.feedback.overall, 10)) /
          6;
        totalrows = totalrows + 1;
        totalavg += avg;
        totalclarity += parseInt(response.feedback.clarity, 10);
        totalobj += parseInt(response.feedback.objective, 10);
        totaldemo += parseInt(response.feedback.demonstration, 10);
        totalfac += parseInt(response.feedback.faculty, 10);
        totallearn += parseInt(response.feedback.learning, 10);
        // totalmat+=parseInt(response.feedback.coursematerial)
        totalov += parseInt(response.feedback.overall, 10);

        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th style={{ textAlign: "right" }}>{key + 1}</th>
            <td>{response.name}</td>
            <td style={{ textAlign: "right" }}>{response.feedback.clarity}</td>
            <td style={{ textAlign: "right" }}>
              {response.feedback.objective}
            </td>
            <td style={{ textAlign: "right" }}>{response.feedback.learning}</td>
            <td style={{ textAlign: "right" }}>{response.feedback.faculty}</td>
            <td style={{ textAlign: "right" }}>
              {response.feedback.demonstration}
            </td>
            {/* <td>{response.feedback.coursematerial}</td> */}
            <td style={{ textAlign: "right" }}>{response.feedback.overall}</td>
            {/* <td>{response.feedback.comment}</td> */}

            <td style={{ textAlign: "right", fontWeight: "bold" }}>
              {Number(avg).toFixed(2)}
            </td>
          </tr>
        );
      });

      console.log(totalrows);
      console.log(totalclarity / totalrows);
    }
    return (
      <Row className="justify-content-md-center">
        <Col md="12">
          <Card>
            {/* <h4 style={{color:"#3f51b5",textAlign:"center", paddingLeft:"20px", paddingTop:"10px"}}>{lecture_name}</h4>
                 <h4 style={{color:"#3f51b5",textAlign:"center", paddingLeft:"20px", paddingTop:"10px"}}>{topic}</h4>
                 <h4 style={{color:"#3f51b5",textAlign:"center", paddingLeft:"20px", paddingTop:"10px"}}>Feedback</h4> */}

            <CardBody>
              <Link
                className="btn grey"
                to={`/session-feedback-course-report/${this.state.course_id}`}
              >
                Back
              </Link>
              {/* <Button className="btn primary" onClick={this.exportToPdf}>Export To Pdf </Button> */}
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="exportbuttonstyle"
                table="table-to-xls"
                filename={this.props.match.params.id}
                sheet="tablexls"
                buttonText="Export As Excel"
              />
              <table
                id="table-to-xls"
                className="table table-bordered table-responsive-md"
                cellSpacing="0"
                width="60%"
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th
                      colspan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h4>Session Wise Feedback Report</h4>
                    </th>{" "}
                  </tr>
                  <tr>
                    <th
                      colspan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h4>
                        Course Name: {this.props.match.params.course_name}
                      </h4>
                    </th>
                  </tr>
                  <tr>
                    <th
                      colspan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h4 style={{ fontWeight: "bold" }}>Topic: {topic}</h4>
                    </th>
                  </tr>

                  <tr>
                    <th
                      colspan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h5>
                        Lecturer Name: {lecture_name} &nbsp;&nbsp; Date:{" "}
                        {moment(this.state.session_date).format("DD/MM/YYYY")}{" "}
                        &nbsp;&nbsp; Time: {this.state.start_time} to{" "}
                        {this.state.end_time}
                      </h5>{" "}
                      <p style={{ textAlign: "right" }}>
                        Scale (5- Excellent, 4- VeryGood, 3- Good, 2- Just Fair,
                        1- Poor)
                      </p>
                    </th>
                  </tr>

                  <tr>
                    <th scope="col" width="20">
                      S. No
                    </th>
                    <th scope="col" width="200">
                      Trainee Name
                    </th>
                    <th scope="col" width="100">
                      Clarity of Session Objective
                    </th>
                    <th scope="col" width="100">
                      Whether Objective met
                    </th>
                    <th scope="col" width="100">
                      Learning new Concepts
                    </th>
                    <th scope="col" width="100">
                      Faculty Presentation Skills
                    </th>
                    <th scope="col" width="100">
                      Usefulness of Presentation Material / Practical Handouts
                    </th>
                    {/* <th scope="col">Course material</th> */}
                    <th scope="col" width="100">
                      Overall Session Evaluation
                    </th>
                    {/* <th scope="col">Comment</th> */}
                    <th scope="col" width="100" style={{ fontWeight: "bold" }}>
                      Average
                    </th>
                    {/* <th scope="col">Average</th> */}
                  </tr>
                </thead>
                <tbody>
                  {feedbackTable}
                  <tr>
                    <td></td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      Total
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalclarity / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalobj / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totallearn / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalfac / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totaldemo / totalrows).toFixed(2)}
                    </td>
                    {/* <td>{Number(totalmat/totalrows).toFixed(2)}</td> */}
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalov / totalrows).toFixed(2)}
                    </td>

                    <td
                      style={{
                        textAlign: "right",
                        color: "blue",
                        fontSize: "20px",
                      }}
                    >
                      {Number(totalavg / totalrows).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div id="content" hidden>
                <h4
                  style={{
                    textAlign: "center",
                    backgroundColor: "#FFFFFF",
                    border: "0",
                    color: "#3f51b5",
                  }}
                >
                  Session Wise Feedback Report
                </h4>

                <h4
                  style={{ textAlign: "center", border: "0", color: "#3f51b5" }}
                >
                  Course Name: {this.props.match.params.course_name}
                </h4>

                <h4
                  style={{
                    textAlign: "center",
                    border: "0",
                    color: "#3f51b5",
                    fontStyle: "bold",
                  }}
                >
                  Topic: {topic}
                </h4>

                <h5
                  style={{ textAlign: "center", border: "0", color: "#3f51b5" }}
                >
                  Lecturer Name: {lecture_name} &nbsp;&nbsp; Date:{" "}
                  {moment(this.state.session_date).format("DD/MM/YYYY")}{" "}
                  &nbsp;&nbsp; Time: {this.state.start_time} to{" "}
                  {this.state.end_time}
                </h5>
                <p style={{ textAlign: "right" }}>
                  Scale (5- Excellent, 4- VeryGood, 3- Good, 2- Just Fair, 1-
                  Poor)
                </p>
              </div>
              <table
                id="table-to-pdf"
                className="table table-bordered table-responsive-md"
                cellSpacing="0"
                width="60%"
                hidden
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th scope="col" width="20">
                      S. No
                    </th>
                    <th scope="col" width="200">
                      Trainee Name
                    </th>
                    <th scope="col" width="100">
                      Clarity of Session Objective
                    </th>
                    <th scope="col" width="100">
                      Whether Objective met
                    </th>
                    <th scope="col" width="100">
                      Learning new Concepts
                    </th>
                    <th scope="col" width="100">
                      Faculty Presentation Skills
                    </th>
                    <th scope="col" width="100">
                      Usefulness of Presentation Material / Practical Handouts
                    </th>
                    {/* <th scope="col">Course material</th> */}
                    <th scope="col" width="100">
                      Overall Session Evaluation
                    </th>
                    {/* <th scope="col">Comment</th> */}
                    <th scope="col" width="100" style={{ fontWeight: "bold" }}>
                      Average
                    </th>
                    {/* <th scope="col">Average</th> */}
                  </tr>
                </thead>
                <tbody>
                  {feedbackTable}
                  <tr>
                    <td></td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      Total
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalclarity / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalobj / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totallearn / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalfac / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totaldemo / totalrows).toFixed(2)}
                    </td>
                    {/* <td>{Number(totalmat/totalrows).toFixed(2)}</td> */}
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalov / totalrows).toFixed(2)}
                    </td>

                    <td
                      style={{
                        textAlign: "right",
                        color: "blue",
                        fontSize: "20px",
                      }}
                    >
                      {Number(totalavg / totalrows).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
